import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaClock, FaChevronLeft, FaLinkedin, FaTwitter, FaFacebook, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog11 = () => {
    const blogPost = {
        id: 1,
        title: "Apports en capital dans l'espace OHADA : maîtrisez les règles pour chaque type de société",
        excerpt: "Le capital social est le socle sur lequel repose toute entreprise. Découvrez comment constituer votre capital selon votre forme de société (SNC, SCS, SARL, SA, SAS) dans l'espace OHADA.",
        content: `
      <div class="intro-section">
        <p>Le capital social est le socle sur lequel repose toute entreprise. Pour vous, créateur d'entreprise dans l'un des 17 États de l'espace OHADA, la constitution de ce capital est bien plus qu'une formalité : c'est votre premier acte stratégique. Il détermine la crédibilité de votre projet, la répartition du pouvoir et votre responsabilité future.</p>
        
        <p>En tant que cabinet d'expertise comptable, <strong>CINEF EXPERTISE</strong> a conçu ce guide complet pour éclairer votre parcours. Nous allons décortiquer, avec les références de l'Acte Uniforme relatif au Droit des Sociétés Commerciales et du Groupement d'Intérêt Économique (AUDSCGIE), les différents types d'apports et leurs spécificités pour chaque forme de société.</p>
      </div>
      
      <div class="highlight-box">
        <h3>Le Capital Social : Rôle et Importance Stratégique</h3>
        <p>Avant la technique, la stratégie. Le capital social, défini à l'Article 37 de l'AUDSCGIE, est constitué des apports des associés et est divisé en titres sociaux (parts sociales ou actions). Il remplit trois fonctions vitales :</p>
        
        <div class="fonction-grid">
          <div class="fonction-card">
            <div class="fonction-number">1</div>
            <h4>Fonction de Financement</h4>
            <p>C'est la première ressource de l'entreprise. Elle finance les investissements de départ et le besoin en fonds de roulement (BFR) pour lancer l'activité sereinement.</p>
          </div>
          
          <div class="fonction-card">
            <div class="fonction-number">2</div>
            <h4>Fonction de Gage pour les Créanciers</h4>
            <p>Il représente la garantie initiale offerte aux tiers (banques, fournisseurs). Un capital solide inspire confiance.</p>
          </div>
          
          <div class="fonction-card">
            <div class="fonction-number">3</div>
            <h4>Fonction de Répartition du Pouvoir</h4>
            <p>La proportion du capital détenue par chaque associé détermine l'étendue de ses droits : droit de vote aux assemblées, droit aux dividendes et droit à l'information.</p>
          </div>
        </div>
      </div>
      
      <h2 class="section-title">Tableau Synthétique des Apports par Forme de Société</h2>
      <p>Pour une vision d'ensemble, voici les règles applicables à chaque type de société commerciale :</p>
      
      <div class="table-responsive">
        <table class="tableau-apports">
          <thead>
            <tr>
              <th>Type de Société</th>
              <th>Apport en Numéraire</th>
              <th>Apport en Nature (CAA)</th>
              <th>Apport en Industrie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>SNC</strong><br/><small>Société en Nom Collectif</small></td>
              <td>Statuts fixent les modalités</td>
              <td>Non obligatoire (associés responsables)</td>
              <td class="text-success"><strong>✓ Oui</strong></td>
            </tr>
            <tr>
              <td><strong>SCS</strong><br/><small>Société en Commandite Simple</small></td>
              <td>Statuts fixent les modalités</td>
              <td>Non obligatoire (associés responsables)</td>
              <td class="text-success"><strong>✓ Oui</strong> (pour les commandités)</td>
            </tr>
            <tr>
              <td><strong>SARL</strong><br/><small>Société à Responsabilité Limitée</small></td>
              <td>50% à la constitution</td>
              <td>Obligatoire, sauf conditions strictes</td>
              <td class="text-success"><strong>✓ Oui</strong></td>
            </tr>
            <tr>
              <td><strong>SA</strong><br/><small>Société Anonyme</small></td>
              <td>25% à la constitution</td>
              <td>Toujours obligatoire</td>
              <td class="text-danger"><strong>✗ Non</strong> (en principe)</td>
            </tr>
            <tr>
              <td><strong>SAS</strong><br/><small>Société par Actions Simplifiée</small></td>
              <td>25% minimum (statuts décident)</td>
              <td>Toujours obligatoire</td>
              <td class="text-success"><strong>✓ Oui</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <p class="transition-text">Explorons maintenant chaque type d'apport en détail.</p>
      
      <div class="apport-section">
        <div class="apport-header">
          <span class="apport-number">1</span>
          <h2>L'Apport en Numéraire (Les Fonds)</h2>
        </div>
        
        <p>C'est l'apport d'une somme d'argent. Il doit être déposé sur un compte bancaire bloqué au nom de la "société en formation" ou chez un notaire. L'attestation de dépôt des fonds est une pièce maîtresse pour l'immatriculation. La "libération" (versement effectif) varie grandement.</p>
        
        <div class="details-grid">
          <div class="detail-card">
            <h4>Dans les SNC et SCS</h4>
            <p>La loi n'impose pas de libération partielle minimale. Les statuts organisent librement les modalités et délais de versement des fonds promis.</p>
          </div>
          
          <div class="detail-card">
            <h4>Dans la SARL</h4>
            <p>La libération doit être d'au moins la moitié (50%) du montant des apports en numéraire à la constitution. Le solde doit être versé dans un délai maximum de deux (2) ans (Article 311-1 de l'AUDSCGIE).</p>
          </div>
          
          <div class="detail-card">
            <h4>Dans la SA et la SAS</h4>
            <p>La libération doit être d'au moins un quart (25%) à la constitution. Le surplus doit être libéré dans un délai de trois (3) ans (Articles 389 de l'AUDSCGIE). Pour la SAS, les statuts peuvent prévoir une libération initiale supérieure à ce minimum.</p>
          </div>
        </div>
      </div>
      
      <div class="apport-section">
        <div class="apport-header">
          <span class="apport-number">2</span>
          <h2>L'Apport en Nature (Les Biens)</h2>
        </div>
        
        <p>Il s'agit de tout bien autre que de l'argent (véhicule, immeuble, fonds de commerce, brevet, etc.). L'enjeu majeur est son évaluation juste et équitable, d'où le rôle du Commissaire aux Apports (CAA).</p>
        
        <div class="details-grid">
          <div class="detail-card">
            <h4>Dans les SNC et SCS</h4>
            <p>Pas de CAA imposé. Les associés évaluent eux-mêmes les biens. En contrepartie de cette liberté, ils sont indéfiniment et solidairement responsables sur leurs biens personnels de la valeur qu'ils ont attribuée. L'erreur d'évaluation a des conséquences illimitées.</p>
          </div>
          
          <div class="detail-card">
            <h4>Dans la SARL</h4>
            <p>Le recours à un CAA est le principe (Article 312). Par exception, les associés peuvent s'en passer si la valeur d'aucun ou de l'ensemble des apports en nature n'excèdent 5 000 000 FCFA. En l'absence de CAA, ils sont solidairement responsables de la valeur retenue pendant cinq ans.</p>
          </div>
          
          <div class="detail-card">
            <h4>Dans la SA et la SAS</h4>
            <p>Le recours à un CAA est systématiquement obligatoire, sans aucune exception possible. Son rapport est une condition de validité de la constitution (Articles 400 et 853-3).</p>
          </div>
        </div>
      </div>
      
      <div class="apport-section">
        <div class="apport-header">
          <span class="apport-number">3</span>
          <h2>L'Apport en Industrie (Le Savoir-Faire)</h2>
        </div>
        
        <p>Cet apport consiste en la mise à disposition de compétences, de travail ou de services.</p>
        
        <div class="principe-box">
          <strong>Principe Fondamental :</strong> L'Apport en Industrie ne concourt JAMAIS à la formation du Capital Social (Article 50-3 de l'AUDSCGIE).
        </div>
        
        <p>Il ne constitue pas un gage pour les créanciers. En échange, l'associé reçoit des "parts d'industrie", qui lui donnent droit au partage des bénéfices et au vote, mais qui sont personnelles et intransmissibles.</p>
        
        <div class="industrie-grid">
          <div class="industrie-card possible">
            <h4>Sociétés où il est possible</h4>
            <p>Il est admis dans les <strong>SNC, SCS</strong> (pour les associés commandités), <strong>SARL</strong> et <strong>SAS</strong>. Les statuts doivent en prévoir les modalités, la durée et la rémunération.</p>
          </div>
          
          <div class="industrie-card interdit">
            <h4>Sociétés où il est exclu</h4>
            <p>L'apport en industrie est en principe interdit dans la <strong>SA</strong>, où le capital doit être intégralement composé de biens saisissables.</p>
          </div>
        </div>
      </div>
      
      <div class="warning-box">
        <h3>⚠️ Point de Vigilance : Le Piège du Compte Courant d'Associé</h3>
        <p>Ne confondez jamais un apport en capital avec un apport en compte courant d'associé. Ce dernier n'est pas un apport mais un <strong>prêt</strong> que l'associé consent à la société. Il s'agit d'une dette qui a vocation à être remboursée et qui ne donne droit à aucune part sociale ou action supplémentaire.</p>
      </div>
      
      <div class="conclusion-section">
        <h2>Conclusion : Votre Capital, Votre Stratégie</h2>
        <p>Vous l'aurez compris, la constitution du capital social en droit OHADA est un exercice précis où chaque choix de forme sociale et de type d'apport emporte des conséquences juridiques, fiscales et financières majeures. La flexibilité de la SAS n'implique pas les mêmes garanties que la rigueur de la SA, et la liberté de la SNC a pour corollaire une responsabilité illimitée.</p>
        
        <p>Bâtir sur des fondations saines et conformes est le premier gage de pérennité. Pour naviguer avec assurance dans ces choix complexes et structurer un capital au service de votre ambition, l'expertise d'un professionnel est indispensable.</p>
        
        <div class="cta-box">
          <p><strong>Faites appel à un expert-comptable</strong> pour vous assurer que vos apports sont à la fois conformes à la loi et alignés sur vos objectifs.</p>
        </div>
      </div>
      
      <div class="ressources-finales">
        <h3>Pour Aller plus loin :</h3>
        <ul>
          <li>Site officiel de l'OHADA : <a href="http://www.ohada.org" target="_blank">www.ohada.org</a></li>
          <li>Jurisprudence et documentation : <a href="http://www.ohada.com" target="_blank">www.ohada.com</a></li>
          <li>Site de l'Ordre des Experts-comptables : <a href="https://oeccabenin.bj/" target="_blank">oeccabenin.bj</a></li>
        </ul>
      </div>
    `,
        categories: ["Droit des Sociétés", "OHADA", "Capital Social"],
        tags: ["Capital Social", "OHADA", "SNC", "SARL", "SA", "SAS", "Apports"],
        date: "10 Octobre 2025",
        author: "Expert CINEF-EC",
        authorTitle: "Expert en Droit des Sociétés OHADA",
        readTime: "12 min",
        featured: true
    };

    const similarBlogs = [
        {
            id: 2,
            title: "Guide complet pour créer votre SARL au Bénin",
            image: "/assets/images/image7.png",
            date: "5 octobre 2025",
            category: "Création d'entreprise"
        },
        {
            id: 3,
            title: "SAS ou SARL : Quelle forme juridique choisir ?",
            image: "/assets/images/image8.png",
            date: "28 septembre 2025",
            category: "Droit des sociétés"
        }
    ];

    return (
        <>
            <Header />

            <div className="blog-content py-5">
                <div className="container">
                    <nav className="breadcrumb-container mb-4">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/" className="text-decoration-none">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog" className="text-decoration-none">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Apports en Capital OHADA
                            </li>
                        </ol>
                    </nav>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog-header mb-4">
                                <div className="categories-badges mb-3">
                                    {blogPost.categories.map((category, index) => (
                                        <span key={index} className="category-badge me-2">{category}</span>
                                    ))}
                                </div>
                                <h1 className="blog-title">{blogPost.title}</h1>

                                <div className="blog-meta d-flex align-items-center flex-wrap mt-3">
                                    <div className="meta-item d-flex align-items-center me-4 mb-2">
                                        <FaCalendarAlt className="meta-icon me-2" />
                                        <span>{blogPost.date}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center me-4 mb-2">
                                        <FaUser className="meta-icon me-2" />
                                        <span>{blogPost.author}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center mb-2">
                                        <FaClock className="meta-icon me-2" />
                                        <span>{blogPost.readTime} de lecture</span>
                                    </div>
                                </div>
                            </div>

                            <div className="blog-excerpt mb-4">
                                <p className="lead">{blogPost.excerpt}</p>
                            </div>

                            <div className="blog-body mb-5" dangerouslySetInnerHTML={{ __html: blogPost.content }} />

                            <div className="blog-tags mb-4">
                                {blogPost.tags.map((tag, index) => (
                                    <Link key={index} to={``} className="blog-tag">
                                        #{tag}
                                    </Link>
                                ))}
                            </div>

                            <div className="blog-share mb-5">
                                <h5 className="share-title">Partager cet article</h5>
                                <div className="social-buttons">
                                    <a href="#" className="social-button linkedin">
                                        <FaLinkedin />
                                    </a>
                                    <a href="#" className="social-button twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="#" className="social-button facebook">
                                        <FaFacebook />
                                    </a>
                                </div>
                            </div>

                            <div className="blog-actions mb-5">
                                <Link to="/actualites/blog" className="btn btn-back">
                                    <FaChevronLeft className="me-2" /> Retour au blog
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="sidebar-widget author-widget">
                                <h4 className="widget-title">À propos de l'auteur</h4>
                                <div className="author-profile">
                                    
                                    <div className="author-info">
                                        <h5 className="author-name">{blogPost.author}</h5>
                                        <p className="author-title">{blogPost.authorTitle}</p>
                                        <p className="author-bio">Spécialiste du droit des sociétés commerciales dans l'espace OHADA avec une expertise pointue dans la constitution et la structuration du capital social des entreprises.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-widget similar-blogs-widget">
                                <h4 className="widget-title">Articles similaires</h4>
                                <div className="similar-blogs">
                                    {similarBlogs.map((similarBlog) => (
                                        <Link key={similarBlog.id} to={`/blog/${similarBlog.id}`} className="similar-blog">
                                            <div className="similar-blog-image">
                                                <img src={similarBlog.image} alt={similarBlog.title} className="img-fluid rounded" />
                                                <span className="category-badge small">{similarBlog.category}</span>
                                            </div>
                                            <div className="similar-blog-content">
                                                <h5 className="similar-blog-title">{similarBlog.title}</h5>
                                                <div className="similar-blog-date">
                                                    <FaCalendarAlt className="me-1" size={12} />
                                                    <small>{similarBlog.date}</small>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="sidebar-widget newsletter-widget">
                                <h4 className="widget-title">Newsletter</h4>
                                <p className="newsletter-desc">Recevez nos guides pratiques sur le droit des sociétés et la création d'entreprise</p>
                                <form className="newsletter-form">
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control" placeholder="Votre adresse email" required />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">S'abonner</button>
                                </form>
                            </div>

                            <div className="sidebar-widget categories-widget">
                                <h4 className="widget-title">Ressources OHADA</h4>
                                <ul className="categories-list">
                                    <li><a href="https://www.ohada.org" target="_blank" rel="noopener noreferrer">Site officiel OHADA <span>→</span></a></li>
                                    <li><a href="https://www.ohada.com" target="_blank" rel="noopener noreferrer">Jurisprudence OHADA <span>→</span></a></li>
                                    <li><a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">Ordre des Experts-Comptables <span>→</span></a></li>
                                    <li><Link to="/services/comptabilite-fiscalite">Nos services <span>→</span></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

        * {
          font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .blog-content {
          background: #f8f9fa;
          min-height: 100vh;
        }

        .breadcrumb {
          background: transparent;
          padding: 0;
          margin: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #9ca3af;
          content: "›";
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: #6b7280;
          text-decoration: none;
          transition: color 0.2s ease;
          font-weight: 500;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #1f2937;
          font-weight: 600;
        }

        .blog-header {
          margin-bottom: 2rem;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 0.4rem 1.2rem;
          border-radius: 25px;
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .blog-title {
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          color: #111827;
          margin-top: 1rem;
        }

        .blog-meta {
          padding: 1rem 0;
          border-top: 2px solid #e5e7eb;
          border-bottom: 2px solid #e5e7eb;
          margin-top: 1.5rem;
        }

        .meta-item {
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .meta-icon {
          color: #dc2626;
        }

        .blog-excerpt {
          background: white;
          border-left: 5px solid #dc2626;
          padding: 2rem;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }

        .blog-excerpt .lead {
          font-size: 1.15rem;
          font-weight: 400;
          line-height: 1.8;
          color: #374151;
          margin: 0;
        }

        .blog-body {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #374151;
        }

        .intro-section {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 2.5rem;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }

        .intro-section p {
          margin-bottom: 1.2rem;
        }

        .highlight-box {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          padding: 2.5rem;
          border-radius: 12px;
          margin: 2.5rem 0;
          border: 2px solid #fbbf24;
        }

        .highlight-box h3 {
          color: #dc2626;
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          text-align: center;
        }

        .fonction-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .fonction-card {
          background: white;
          padding: 1.75rem;
          border-radius: 10px;
          box-shadow: 0 3px 15px rgba(0,0,0,0.08);
          position: relative;
        }

        .fonction-number {
          position: absolute;
          top: -15px;
          left: 20px;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1.25rem;
        }

        .fonction-card h4 {
          color: #111827;
          font-size: 1.1rem;
          font-weight: 600;
          margin-top: 1rem;
          margin-bottom: 0.75rem;
        }

        .fonction-card p {
          color: #4b5563;
          font-size: 0.95rem;
          line-height: 1.6;
          margin: 0;
        }

        .section-title {
          font-size: 2rem;
          font-weight: 700;
          color: #111827;
          margin: 3rem 0 1.5rem 0;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid #dc2626;
        }

        .table-responsive {
          margin: 2rem 0;
          overflow-x: auto;
        }

        .tableau-apports {
          width: 100%;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }

        .tableau-apports thead {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
        }

        .tableau-apports th {
          padding: 1.25rem;
          font-weight: 600;
          font-size: 0.95rem;
          text-align: left;
        }

        .tableau-apports td {
          padding: 1.25rem;
          border-bottom: 1px solid #e5e7eb;
          font-size: 0.925rem;
        }

        .tableau-apports tbody tr:hover {
          background: #f9fafb;
        }

        .tableau-apports small {
          display: block;
          color: #6b7280;
          font-size: 0.8rem;
          margin-top: 0.25rem;
        }

        .text-success {
          color: #16a34a !important;
        }

        .text-danger {
          color: #dc2626 !important;
        }

        .transition-text {
          text-align: center;
          font-size: 1.15rem;
          font-weight: 500;
          color: #4b5563;
          margin: 2.5rem 0;
          font-style: italic;
        }

        .apport-section {
          background: white;
          padding: 2.5rem;
          border-radius: 12px;
          margin: 2.5rem 0;
          box-shadow: 0 3px 15px rgba(0,0,0,0.06);
        }

        .apport-header {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .apport-number {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1.75rem;
          flex-shrink: 0;
        }

        .apport-header h2 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #111827;
            margin: 0;
        }
        .apport-section p {
          color: #1c2424ff;
          font-size: 1rem;
          line-height: 1.7;
          margin-bottom: 1.5rem;
        }
        .details-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 1.5rem;
        }
        .detail-card {
            background: #f9fafb;
            padding: 1.5rem;
            border-radius: 10px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }
        .detail-card h4 {
            color: #dc2626;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.75rem;
        }
        .detail-card p {
            color: #4b5563;
            font-size: 0.95rem;
            line-height: 1.6;
            margin: 0;
        }
        .principe-box {
            background: #fef3c7;
            border-left: 5px solid #f59e0b;
            padding: 1rem 1.5rem;
            border-radius: 8px;
            font-weight: 600;
            color: #92400e;
            margin-bottom: 1.5rem;
        }
        .industrie-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 1.5rem;
            margin-top: 1rem;
        }
        .industrie-card {
            padding: 1.5rem;
            border-radius: 10px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            color: white;
        }
        .industrie-card.possible {
            background: linear-gradient(135deg, #16a34a, #4ade80);
        }
        .industrie-card.interdit {
            background: linear-gradient(135deg, #dc2626, #f87171);
          
        }
        .industrie-card h4 {
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.75rem;
        }
        .industrie-card p {
            font-size: 0.95rem;
            line-height: 1.6;
            margin: 0;
        }
        .warning-box {
            background: #fee2e2;
            border-left: 5px solid #dc2626;
            padding: 1.5rem 2rem;
            border-radius: 10px;
            margin: 2.5rem 0;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }
        .warning-box h3 {
            color: #b91c1c;
            font-size: 1.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
        }
        .warning-box p {
            color: #991b1b;
            font-size: 1rem;
            line-height: 1.6;
            margin: 0;
        }
        .conclusion-section {
            background: white;
            padding: 2.5rem;
            border-radius: 12px;
            margin: 2.5rem 0;
            box-shadow: 0 3px 15px rgba(0,0,0,0.06);
        }
        .conclusion-section h2 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 1.5rem;
        }
        .conclusion-section p {
            color: #4b5563;
            font-size: 1rem;
            line-height: 1.7;
            margin-bottom: 1.5rem;
        }
        .cta-box {
            background: #63dc2679;
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .cta-box p {
            font-size: 1.1rem;
            font-weight: 600;
            margin: 0;
        }
        .ressources-finales {
            margin-top: 2.5rem;
            padding: 1.5rem 2rem;
            background: #f3f4f6;
            border-radius: 10px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        }
        .ressources-finales h3 {
            font-size: 1.5rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 1rem;    
        }
        .ressources-finales ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .ressources-finales ul li {
            margin-bottom: 0.75rem;
        }
        .ressources-finales ul li a {
            color: #2563eb;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.2s ease;
        }
        .ressources-finales ul li a:hover {
            color: #1e40af;
            text-decoration: underline;
        }
        .blog-tags {
          margin-bottom: 2rem;
        }
        .blog-tag {
            display: inline-block;
            background: #e5e7eb;
            color: #374151;
            padding: 0.4rem 1rem;
            border-radius: 25px;
            font-size: 0.875rem;
            font-weight: 500;
            text-decoration: none;
            margin: 0 0.5rem 0.5rem 0;
            transition: background 0.2s ease, color 0.2s ease;      
        }
        .blog-tag:hover {
            background: #dc2626;
            color: white;
        }
        .blog-share {
            margin-bottom: 2.5rem;
        }
        .share-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #111827;
            margin-bottom: 1rem;
        }
        .social-buttons {
            display: flex;
            gap: 1rem;
        }
        .social-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            color: white;
            font-size: 1.25rem;
            text-decoration: none;
            transition: background 0.2s ease;
        }
        .social-button.linkedin {
            background: #0a66c2;
        }
        .social-button.linkedin:hover {
            background: #004182;
        }
        .social-button.twitter {
            background: #1da1f2;
        }
        .social-button.twitter:hover {
            background: #0d8ddb;
        }
        .social-button.facebook {
            background: #1877f2;
        }
        .social-button.facebook:hover {
            background: #0d5bd1;
        }

        .blog-actions .btn-back {
            display: inline-flex;
            align-items: center;
            background: #e5e7eb;
            color: #374151;
            padding: 0.5rem 1.5rem;
            border-radius: 25px;
            font-size: 0.95rem;
            font-weight: 500;
            text-decoration: none;
            transition: background 0.2s ease, color 0.2s ease;
        }
        .blog-actions .btn-back:hover {
            background: #dc2626;
            color: white;
        }
        .blog-actions .btn-back svg {
            font-size: 1rem;
        }
        .sidebar-widget {
            background: white;
            padding: 1.5rem;
            border-radius: 12px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            margin-bottom: 2.5rem;
        }
        .widget-title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #111827;
            margin-bottom: 1.5rem;
            border-bottom: 3px solid #dc2626;
            padding-bottom: 0.5rem;
        }
        .author-profile {
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .author-image img {
            width: 80px;
            height: 80px;   
            object-fit: cover;
            border-radius: 50%;
            border: 3px solid #dc2626;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .author-info .author-name {
            font-size: 1.1rem;
            font-weight: 600;
            color: #111827;
            margin: 0;
        }
        .author-info .author-title {
            font-size: 0.9rem;
            color: #6b7280;
            margin: 0.25rem 0 0.75rem 0;
        }
        .author-info .author-bio {
            font-size: 0.875rem;
            color: #4b5563;
            margin: 0;
            line-height: 1.6;
        }

        .similar-blogs .similar-blog {
            display: flex;
            gap: 1rem;
            margin-bottom: 1.5rem;
            text-decoration: none;
            color: inherit;
            transition: background 0.2s ease;
        }
        .similar-blogs .similar-blog:hover {
            background: #f9fafb;
            border-radius: 8px;
            padding: 0.5rem;
        }
        .similar-blog-image {
            position: relative;
            flex-shrink: 0;
        }
        .similar-blog-image img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 8px;
        }
        .similar-blog-image .category-badge.small {
            position: absolute;
            top: 5px;
            left: 5px;
            font-size: 0.65rem;
            padding: 0.25rem 0.75rem;
            border-radius: 20px;
        }
        .similar-blog-content {
            flex: 1;
        }
        .similar-blog-title {   
            font-size: 1rem;
            font-weight: 600;
            color: #111827;
            margin: 0 0 0.5rem 0;
        }
        .similar-blog-date {
            display: flex;
            align-items: center;    
            color: #6b7280;
            font-size: 0.875rem;
        }
        .similar-blog-date svg {
            color: #dc2626;
        }
        .newsletter-desc {
            font-size: 0.95rem;
            color: #4b5563;
            margin-bottom: 1rem;
            line-height: 1.6;
        }
        .newsletter-form .form-control {
            border-radius: 25px;
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
            border: 1px solid #d1d5db;
            transition: border-color 0.2s ease;
        }
        .newsletter-form .form-control:focus {
            border-color: #dc2626;
            box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
            outline: none;
        }
        .newsletter-form .btn {
            border-radius: 25px;
            font-size: 0.95rem;
            font-weight: 600;
            transition: background 0.2s ease;
        }
        .newsletter-form .btn:hover {
            background: #b91c1c;
            border-color: #b91c1c;
        }
        .categories-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }
        .categories-list li {
            margin-bottom: 1rem;
        }
        .categories-list li a {
            color: #2563eb;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.2s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .categories-list li a:hover {
            color: #1e40af;
            text-decoration: underline;
        }
        .categories-list li a span {
            font-size: 1.25rem;
            line-height: 1;
        }
        @media (max-width: 767px) {
          .blog-title {
            font-size: 2rem;
            }
            .apport-header {
            flex-direction: column;
            align-items: flex-start;
            }
            .apport-number {
            width: 50px;
            height: 50px;   
            font-size: 1.5rem;
            }
        }
        `}</style>
        </>
    );
};
export default DetailBlog11;